/**
 * Set when retailer dismisses any Sale related announcement
 */ export var SALE_ANNOUNCEMENT_DISMISSED = 'SALE_ANNOUNCEMENT_DISMISSED';
